import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function UserMenu({ openItem = null, activeItem = null }) {
  return (
    <li
      className={`nav-item has-treeview 
        ${sidebarHelper.checkOpenItem(openItem, "users")} `}
    >
      <a
        href="# "
        className={`nav-link  
        ${sidebarHelper.checkActiveItem(openItem, "users")} `}
      >
        <i className="nav-icon fa hl-user"></i>
        <p>
          مدیریت کاربران
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/user/all"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(activeItem, "user-all")} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>همه کاربران</p>{" "}
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/user/marketer/all"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(activeItem, "all-marketer")} `}
          >
            <i className="fa fa-user nav-icon"></i>
            <p> لیست بازاریابان</p>{" "}
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/user/mobile-replace"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(
              activeItem,
              "all-mobile-replace"
            )} `}
          >
            <i className="fa fa-user nav-icon"></i>
            <p>موبایل جایگزین</p>{" "}
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/user/list-users"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(activeItem, "list-users")} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p>لیست کاربران (اکسل)</p>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/user/notification-dashboard/all"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(
              activeItem,
              "all-notification-dashboard"
            )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p> اطلاع رسانی های داشبورد</p>
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to="/user/notification-private/all"
            className={`nav-link  
            ${sidebarHelper.checkActiveItem(
              activeItem,
              "all-notification-private"
            )} `}
          >
            <i className="fa fa-image nav-icon"></i>
            <p style={{ fontSize: "14px" }}>پیام های خصوصی کاربران</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}

export default UserMenu;
